const obj = {
  id: '',
  eventId: '',
  system: '',
  backgroundImage: '',
  backgroundColor: '',
  textColor: '',
  buttonBackgroundColor: '',
  buttonTextColor: '',
  miceContractId: '',
  photoAttributeId: '',
  detectionType: '',
}

export default function FaceCollectorConfigModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
